// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"A4-z","dimensionLabel":"B4-z","styleChooserControlWrapper":"C4-z","styleChooserControl":"D4-z","disabled":"E4-z","giftCard":"F4-z","styleChooserText":"G4-z"};